module.exports = __webpack_public_path__ + "img/box2.2a528449.png";